// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__15_EE","savePackageButton":"ClientWallet_savePackageButton__1_OZA"};